<script>
  import { query } from "svelte-apollo";
  import { _ as t } from "svelte-i18n";
  import { Title } from "t2c-components";
  import { analyticTrack } from "utils.js";

  import { client } from "apollo.js";
  import { LAWCASE_CLIENT_FOLDER_QUERY } from "./queries.js";

  import SelectorIcon from "components/SelectorIcon.svelte";
  import Breadcrumbs from "components/Breadcrumbs.svelte";
  import Tile from "components/Tile.svelte";
  import Document from "./Document.svelte";
  import FolderTile from "./FolderTile.svelte";
  import FolderList from "./FolderList.svelte";
  import Uppy from "components/Uppy.svelte";

  export let lawcaseId;
  export let folderId;

  let links = [null, null];

  const folder = query(client, {
    query: LAWCASE_CLIENT_FOLDER_QUERY,
    variables: { lawcaseId: lawcaseId, folderId: folderId },
  });

  analyticTrack();

  let allFolders = [];
  const getBreadcrumbs = (last, list) => {
    if (last && last.parentId == null) {
      return [last];
    } else {
      if (last) {
        const parent = allFolders.find((f) => f.id == last.parentId);
        return getBreadcrumbs(parent, list).concat(last);
      } else {
        return [];
      }
    }
  };

  const buildBreadcrumbs = (lawcase) => {
    allFolders = lawcase.folders;

    const base = [
      {
        to: `/lawcase/${lawcaseId}/folders`,
        label: `${lawcase.title}`,
      },
    ];

    const folderLinks = getBreadcrumbs(lawcase.folder, allFolders).map((f) => {
      return {
        to: `/lawcase/${lawcaseId}/folder/${f.id}`,
        label: f.name == "Inbox" ? $t("content.myDocuments") : f.name,
      };
    });

    links = base.concat(folderLinks);
  };

  folder.result().then((result) => {
    buildBreadcrumbs(result.data.lawcaseClient);
  });

  // See https://github.com/ItalyPaleAle/svelte-spa-router/issues/14#issuecomment-544532053
  $: if (folderId) {
    folder.refetch({ folderId }).then((result) => {
      buildBreadcrumbs(result.data.lawcaseClient);
    });
  }

  // ***************************************
  // Display Tiles section
  // ***************************************

  let displayDocuments = localStorage.getItem("display-documents") || "tiles";

  const setDisplayTiles = () => {
    displayDocuments = "tiles";
    localStorage.setItem("display-documents", displayDocuments);
  };
  const setDisplayList = () => {
    displayDocuments = "list";
    localStorage.setItem("display-documents", displayDocuments);
  };

  const handleUploadSuccess = () => {
    folder.refetch();
  };

  const handleUploadFail = (e) => {
    const { error } = e.detail;
    console.log(error);
  };
</script>

<div class="container">
  <section class="wrapper">
    {#await $folder}
      <Breadcrumbs {links} />
      <div class="box">
        <Title title={$t("content.documents")} />
        <p>{$t("loading")}</p>
      </div>
    {:then result}
      <Breadcrumbs {links} />
      <div class="box">
        <div class="box-header">
          <Title title={$t("content.documents")} />
          <div>
            <span style="cursor: pointer" on:click={setDisplayList}>
              <SelectorIcon icon="list" active={!displayDocuments} />
            </span>
            <span style="cursor: pointer" on:click={setDisplayTiles}>
              <SelectorIcon icon="tiles" active={displayDocuments} />
            </span>
          </div>
        </div>
      </div>
      {#if displayDocuments == "tiles"}
        <div class="rows">
          {#each result.data.lawcaseClient.folder.folders as folder (folder.id)}
            <FolderTile {...folder} {lawcaseId} />
          {/each}
          {#each result.data.lawcaseClient.folder.documents as caseDocument (caseDocument.id)}
            <Tile
              link={`/lawcase/${lawcaseId}/folder/${folderId}/document/${caseDocument.id}`}
              document={caseDocument}
            />
          {/each}
        </div>
      {:else}
        <div>
          {#each result.data.lawcaseClient.folder.folders as folder (folder.id)}
            <FolderList {...folder} {lawcaseId} />
          {/each}
          {#each result.data.lawcaseClient.folder.documents as caseDocument (caseDocument.id)}
            <Document document={caseDocument} {lawcaseId} {folderId} />
          {/each}
        </div>
      {/if}
    {/await}
    <Uppy
      {lawcaseId}
      {folderId}
      on:success={handleUploadSuccess}
      on:fail={handleUploadFail}
    />
  </section>
</div>

<style>
  .container {
    width: 100%;
    font-weight: 400;
  }

  .wrapper {
    margin: 0 auto;
    max-width: 1020px;
  }

  .box {
    padding-top: 24px;
    border-top: 1px solid var(--blue-color);
  }

  .box:first-child {
    border-top: 0;
  }

  .box-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .rows {
    margin: 16px 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, 250px);
    grid-gap: 20px;
  }
</style>
